// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSearchOffersForHouseCardMobileSiteRequest,
  TSearchOffersForHouseCardMobileSiteModel,
  IMappers,
  TSearchOffersForHouseCardMobileSiteResponse_,
  TSearchOffersForHouseCardMobileSiteResponse,
  TSearchOffersForHouseCardMobileSiteResponse_1,
  TSearchOffersForHouseCardMobileSiteResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createSearchOffersForHouseCardMobileSiteModel(
  parameters: TSearchOffersForHouseCardMobileSiteRequest,
): TSearchOffersForHouseCardMobileSiteModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-engine',
    pathApi: '/v1/search-offers-for-house-card-mobile-site/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISearchOffersForHouseCardMobileSiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSearchOffersForHouseCardMobileSiteRequest;
}

export async function fetchSearchOffersForHouseCardMobileSite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchOffersForHouseCardMobileSiteOptions<TResponse200, TResponse400>): Promise<
  TSearchOffersForHouseCardMobileSiteResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchOffersForHouseCardMobileSiteModel(parameters),
    config,
  )) as FetchResponse<TSearchOffersForHouseCardMobileSiteResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSearchOffersForHouseCardMobileSiteResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TSearchOffersForHouseCardMobileSiteResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TSearchOffersForHouseCardMobileSiteResponse;
}
